import $ from 'jquery';


export default () => {
    $(document).ready(function()
    {
        var $input_code = $("#input-giulio-code");
        var $cta = $("#cta-validate-code");
        var $label_status = $("#label-code-status");

        $cta.on('click', function (e)
        {
            e.preventDefault();
            $cta.attr("disabled", true);
            var codice = $input_code.val();

            if(codice && codice.length > 0)
            {
                window.check_code_validation(codice)
                    .then(function (res) {
                        if(res.is_valid)
                        {
                            $label_status.removeClass("invalid").addClass("valid");
                            $label_status.text($label_status.attr("label-success"));
                            location.href = window.success_url + "?c=" + codice;
                        }
                        else
                        {
                            $label_status.removeClass("valid").addClass("invalid");
                            $label_status.text($label_status.attr("label-error"));
                            $cta.attr("disabled", false);
                        }

                    })
                    .catch(function (err) {
                        $cta.attr("disabled", false);
                    });
            }
        });
    });
};



// WEBPACK FOOTER //
// ./scripts/libs/modal-validate.js